import { Stack } from '@mui/material'
import { TwinResponderLabel, TwinResponderThread } from 'api/model'
import { useEffect, useState } from 'react'
import Threads from './Threads'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'
import { COLORS } from 'app-constants'

const Drafts = ({
  twinResponderLabels,
}: {
  isLoadingLabels: boolean
  twinResponderLabels: TwinResponderLabel[]
  selectedTwinResponderLabels: TwinResponderLabel[]
}) => {
  const isMobile = useCheckMobileScreen()

  const [labelId, setLabelId] = useState<string>('')
  useEffect(() => {
    if (twinResponderLabels.length > 0) {
      setLabelId(twinResponderLabels[0].id)
    }
  }, [twinResponderLabels])

  const [previewedThread, setPreviewedThread] = useState<TwinResponderThread | null>(null)
  const onPreviewThread = (thread: TwinResponderThread) => {
    setPreviewedThread(thread)
  }

  const onBackClick = () => {
    setPreviewedThread(null)
  }

  return (
    <Stack
      p={2}
      direction={isMobile ? 'column' : 'row'}
      spacing={3}
      width="100%"
      sx={{
        height: '100vh',
        backgroundColor: COLORS.GRAY_8,
      }}>
      <Threads
        onBackClick={onBackClick}
        previewedThread={previewedThread}
        setPreviewedThread={setPreviewedThread}
        labelId={labelId}
        onPreviewThread={onPreviewThread}
      />
    </Stack>
  )
}

export default Drafts
